const requestCache = new Map();

export const getCachedRequest = (key, request, maxAge = 0) => {
  const now = Date.now();
  const cached = requestCache.get(key);

  if (cached?.promise) return cached.promise;
  if (cached?.hasValue && now - cached.updatedAt < maxAge) {
    return Promise.resolve(cached.value);
  }

  const promise = Promise.resolve()
    .then(request)
    .then((value) => {
      requestCache.set(key, {
        hasValue: true,
        value,
        updatedAt: Date.now(),
        promise: null,
      });
      return value;
    })
    .catch((error) => {
      if (cached?.hasValue) requestCache.set(key, cached);
      else requestCache.delete(key);
      throw error;
    });

  requestCache.set(key, {
    hasValue: Boolean(cached?.hasValue),
    value: cached?.value,
    updatedAt: cached?.updatedAt || 0,
    promise,
  });
  return promise;
};

export const clearCachedRequest = (key) => {
  if (key === undefined) requestCache.clear();
  else requestCache.delete(key);
};

export const setCachedRequest = (key, value) => {
  requestCache.set(key, {
    hasValue: true,
    value,
    updatedAt: Date.now(),
    promise: null,
  });
};
